export enum BaseURL {
  // BASE_URL = "https://apitqf.fte.rmuti.ac.th/api",
  // BASE_URL = "http://localhost:3004/api",
  // BASE_URL = "http://localhost:5500/api",
  BASE_URL = "https://tqf.fte.rmuti.ac.th/api",
}
